var map = {
	"./bluesky.svg": 42140,
	"./edit_pencil.svg": 48471,
	"./facebook.svg": 66677,
	"./google-sign-in.svg": 25558,
	"./mail.svg": 24836,
	"./messenger-black.svg": 68476,
	"./messenger.svg": 6830,
	"./settings.svg": 25714,
	"./submit-forum-message.svg": 49371,
	"./web-share-api.svg": 29356,
	"./whatsapp.svg": 50519,
	"./x-twitter.svg": 29313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68593;